import { Routes } from '@angular/router';

import { BspceSummaryGuard } from '@features/bspce/guards/bspce-summary.guard';
import { CehrSummaryGuard } from '@features/cehr/guards/cehr-summary.guard';
import { CfagSummaryGuard } from '@features/cfag/guards/cfag-summary.guard';
import { IfiSummaryGuard } from '@features/ifi/guards/ifi-summary.guard';
import { PerSummaryGuard } from '@features/per/guards/per-summary.guard';
import { PfuSummaryGuard } from '@features/pfu/guards/pfu-summary.guard';
import { PviSummaryGuard } from '@features/pvi/guards/pvi-summary.guard';
import { RfvslmnpSummaryGuard } from '@features/rfvslmnp/guards/rfvslmnp-summary.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/all-simulators/all-simulators.component').then(
        (m) => m.AllSimulatorsComponent,
      ),
  },
  {
    path: 'list',
    loadComponent: () =>
      import('./features/simulator-list/simulator-list.component').then(
        (m) => m.SimulatorListComponent,
      ),
  },
  {
    path: 'donation',
    loadComponent: () =>
      import('./features/donation/components/donation.component').then((m) => m.DonationComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'donation-form',
      },
      {
        path: 'donation-form',
        loadComponent: () =>
          import('./features/donation/components/form/donation-form.component').then(
            (m) => m.DonationFormComponent,
          ),
      },
      {
        path: 'summary',
        loadComponent: () =>
          import('./features/donation/components/summary/summary.component').then(
            (m) => m.SummaryComponent,
          ),
      },
    ],
  },
  {
    path: 'per',
    loadComponent: () =>
      import('./features/per/components/per.component').then((m) => m.PerComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'per-form' },
      {
        path: 'per-form',
        loadComponent: () =>
          import('./features/per/components/form/per-form.component').then(
            (m) => m.PerFormComponent,
          ),
      },
      {
        path: 'summary',
        loadComponent: () =>
          import('./features/per/components/summary/per-summary.component').then(
            (m) => m.PerSummaryComponent,
          ),
        canMatch: [PerSummaryGuard],
      },
    ],
  },

  {
    path: 'cfag',
    loadComponent: () =>
      import('./features/cfag/components/cfag.component').then((m) => m.CfagComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'cfag-form',
      },
      {
        path: 'cfag-form',
        loadComponent: () =>
          import('./features/cfag/components/form/cfag-form.component').then(
            (m) => m.CfagFormComponent,
          ),
      },
      {
        path: 'summary',
        loadComponent: () =>
          import('./features/cfag/components/summary/cfag-summary.component').then(
            (m) => m.CfagSummaryComponent,
          ),
        canMatch: [CfagSummaryGuard],
      },
    ],
  },

  {
    path: 'cehr',
    loadComponent: () =>
      import('./features/cehr/components/cehr.component').then((m) => m.CehrComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'cehr-form' },
      {
        path: 'cehr-form',
        loadComponent: () =>
          import('./features/cehr/components/form/cehr-form.component').then(
            (m) => m.CehrFormComponent,
          ),
      },
      {
        path: 'summary',
        loadComponent: () =>
          import('./features/cehr/components/summary/cehr-summary.component').then(
            (m) => m.CehrSummaryComponent,
          ),
        canMatch: [CehrSummaryGuard],
      },
    ],
  },

  {
    path: 'pvi',
    loadComponent: () =>
      import('./features/pvi/components/pvi.component').then((m) => m.PviComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'form' },
      {
        path: 'form',
        loadComponent: () =>
          import('./features/pvi/components/form/form.component').then((m) => m.FormComponent),
      },
      {
        path: 'summary',
        loadComponent: () =>
          import('./features/pvi/components/summary/summary.component').then(
            (m) => m.SummaryComponent,
          ),
        canMatch: [PviSummaryGuard],
      },
    ],
  },

  {
    path: 'vuc',
    loadComponent: () =>
      import('./features/vuc/components/vuc.component').then((m) => m.VucComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'vuc-form' },
      {
        path: 'vuc-form',
        loadComponent: () =>
          import('./features/vuc/components/form/vuc-form.component').then(
            (m) => m.VucFormComponent,
          ),
      },
      {
        path: 'summary',
        loadComponent: () =>
          import('./features/vuc/components/summary/vuc-summary.component').then(
            (m) => m.VucSummaryComponent,
          ),
      },
    ],
  },

  {
    path: 'cofag',
    loadComponent: () =>
      import('./features/cofag/components/cofag.component').then((m) => m.CofagComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'cofag-form',
      },
      {
        path: 'cofag-form',
        loadComponent: () =>
          import('./features/cofag/components/form/cofag-form.component').then(
            (m) => m.CofagFormComponent,
          ),
      },
      {
        path: 'summary',
        loadComponent: () =>
          import('./features/cofag/components/summary/cofag-summary.component').then(
            (m) => m.CofagSummaryComponent,
          ),
      },
    ],
  },

  {
    path: 'pfu',
    loadComponent: () =>
      import('./features/pfu/components/pfu.component').then((m) => m.PfuComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'form' },
      {
        path: 'form',
        loadComponent: () =>
          import('./features/pfu/components/form/pfu-form.component').then(
            (m) => m.PfuFormComponent,
          ),
      },
      {
        path: 'summary',
        loadComponent: () =>
          import('./features/pfu/components/summary/pfu-summary.component').then(
            (m) => m.PfuSummaryComponent,
          ),
        canMatch: [PfuSummaryGuard],
      },
    ],
  },
  {
    path: 'ifi',
    loadComponent: () =>
      import('./features/ifi/components/ifi.component').then((m) => m.IfiComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'ifi-form' },
      {
        path: 'ifi-form',
        loadComponent: () =>
          import('./features/ifi/components/form/ifi-form.component').then(
            (m) => m.IfiFormComponent,
          ),
      },
      {
        path: 'summary',
        loadComponent: () =>
          import('./features/ifi/components/summary/ifi-summary.component').then(
            (m) => m.IfiSummaryComponent,
          ),
        canMatch: [IfiSummaryGuard],
      },
    ],
  },

  {
    path: 'rfvslmnp',
    loadComponent: () =>
      import('./features/rfvslmnp/components/rfvslmnp.component').then((m) => m.RfvslmnpComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'form' },
      {
        path: 'form',
        loadComponent: () =>
          import('./features/rfvslmnp/components/form/form.component').then((m) => m.FormComponent),
      },
      {
        path: 'summary',
        loadComponent: () =>
          import('./features/rfvslmnp/components/summary/summary.component').then(
            (m) => m.SummaryComponent,
          ),
        canMatch: [RfvslmnpSummaryGuard],
      },
    ],
  },
  {
    path: 'bspce',
    loadComponent: () =>
      import('./features/bspce/components/bspce.component').then((c) => c.BspceComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'form' },
      {
        path: 'form',
        loadComponent: () =>
          import('./features/bspce/components/form/bspce-form.component').then(
            (m) => m.BspceFormComponent,
          ),
      },
      {
        path: 'summary',
        loadComponent: () =>
          import('./features/bspce/components/summary/summary.component').then(
            (m) => m.SummaryComponent,
          ),
        canMatch: [BspceSummaryGuard],
      },
    ],
  },
  {
    path: 'erreur',
    loadComponent: () => import('./shared/components/error/error.component').then((m) => m.default),
  },
];
